import { matchPath } from 'react-router';

import { isApplicationNonProd } from 'Utilities/helpers';
import routing from 'Utilities/routing';
import { User } from 'Utilities/user/@types';

const BASE_URL = isApplicationNonProd
  ? 'https://motorway-stage.onelink.me/tpQp'
  : 'https://motorway.onelink.me/gYoi';

const BASE_CTA_LINK = `${BASE_URL}?af_xp=custom&pid=sliplane&c=deferred_link&is_retargeting=true&af_reengagement_window=lifetime`;

const buildDeepLink = (url: string) =>
  `${BASE_CTA_LINK}&deep_link_value=${encodeURIComponent(url)}`;

type GetCTAHrefParams = {
  loginToken?: User['login_token'];
  pathname: string;
  sliplaneUrl?: string;
  xSpId?: string;
};

export const getAppBannerLink = ({ loginToken, pathname, sliplaneUrl, xSpId = '' }: GetCTAHrefParams) => {
  if (!sliplaneUrl) {
    return BASE_CTA_LINK;
  }

  const vrmMatch = matchPath<{ vrm: string }>(pathname, { path: routing.vrmPath });
  const params = new URLSearchParams();

  if (loginToken) {
    params.append('token', loginToken);
    const vrm = vrmMatch?.params?.vrm?.toUpperCase();
    if (vrm) {
      params.append('vrm', vrm);
    }
  }

  if (xSpId) {
    params.append('xSpId', xSpId);
  }

  const queryString = params.toString();

  const urlWithParams = queryString ? `${sliplaneUrl}?${queryString}` : sliplaneUrl;

  return buildDeepLink(urlWithParams);
};
